import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

const MoveModal = ({ onSelect, exercise, modules, onClose }) => {
  return (
    <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
      <DialogTitle>Move: {exercise.name}</DialogTitle>
      <List subheader={<ListSubheader>Select Module</ListSubheader>}>
        {modules.map(i => (
          <ListItem button key={i.id} onClick={() => onSelect(i.id, exercise)}>
            <ListItemText primary={i.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}

export default MoveModal;